import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem('session_token');
  if (token) config.headers['Authorization'] = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    if (err?.response?.status === 401) {
      localStorage.removeItem('session_token');
      window.location.href = '/login';
      return new Promise(() => {});
    }
    return Promise.reject(err);
  }
);

export default api;
export const API_URL = `${BACKEND_URL}/api`;
